import { getContactInfo } from '@/api/index'
import { resolveUrl } from './helper'

let cache = null
let loading = null

export function setContactInfo(info) {
  cache = info || {}
}

export function getContactInfoCache() {
  return cache || {}
}

export async function ensureContactInfo() {
  if (cache) return cache
  if (!loading) {
    loading = getContactInfo()
      .then(info => {
        cache = info || {}
        return cache
      })
      .catch(err => {
        cache = {}
        throw err
      })
      .finally(() => {
        loading = null
      })
  }
  return loading
}

export function getAppDownloadUrl(info) {
  const data = info || cache || {}
  return resolveUrl(data.app_download_url)
}

export async function openAppDownload(vm, info) {
  let contact = info
  if (!contact || !contact.app_download_url) {
    try {
      contact = await ensureContactInfo()
    } catch (e) {
      contact = getContactInfoCache()
    }
  }

  const url = getAppDownloadUrl(contact)
  if (url) {
    window.open(url, '_blank')
    return true
  }

  if (vm && vm.$message) {
    vm.$message.info('APP下载链接暂未配置')
  }
  return false
}
